/* eslint-disable react/no-unescaped-entities */
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import colors from "src/theme/colors";
import { Checkbox, FormControlLabel, IconButton, styled } from "@mui/material";
import { StyledLoadingButton } from "src/components/LoadingButton";
import { ArrowLeft2 } from "iconsax-react";
import { GrayButton } from "src/components/GrayButton";
import { GppBad, GppGood } from "@mui/icons-material";
import { useState } from "react";

type Props = {
  requestName: string;
  isButtonLoading: boolean;
  selectedQuality: string;
  onReject: (dataRemove: boolean) => void;
  onGoBack: () => void;
  onDismiss: () => void;
};

export const RejectResultStep = (props: Props) => {
  const {
    requestName,
    isButtonLoading,
    selectedQuality,
    onReject,
    onGoBack,
    onDismiss,
  } = props;

  const [dataRemoveCheck, setDataRemoveCheck] = useState(true);

  return (
    <Container>
      <Content>
        <Head>
          <IconButton onClick={onGoBack}>
            <ArrowLeft2 size="15" type="bold" color={colors.base.black} />
          </IconButton>
          <IconButton onClick={onDismiss}>
            <img
              src={process.env.PUBLIC_URL + `/assets/icons/close.svg`}
              alt={"close"}
            />
          </IconButton>
        </Head>

        <TitleBar>
          <GppBad fontSize="large" color="secondary" />
          <Box pt={10}>
            <Typography fontSize={18} fontWeight={700} color={colors.gray[850]}>
              Local Inspection Request Result Rejection
            </Typography>
          </Box>
        </TitleBar>

        <SubTitle>
          Are you sure you want to reject test certificate{" "}
          <b>"{requestName}"</b> with quality <b>"{selectedQuality}"</b> ?
        </SubTitle>

        <CheckField>
          <FormControlLabel
            label="Remove data related by this inspection result."
            control={
              <Checkbox
                color="secondary"
                checked={dataRemoveCheck}
                onChange={(e) => setDataRemoveCheck(e.target.checked)}
                name="data remove"
              />
            }
          />
        </CheckField>

        <Actions>
          <CancelButtonBox>
            <GrayButton
              variant="outlined"
              disabled={isButtonLoading}
              fullWidth
              onClick={onDismiss}
            >
              Cancel
            </GrayButton>
          </CancelButtonBox>
          <SubmitButtonBox>
            <StyledLoadingButton
              variant="contained"
              fullWidth
              loading={isButtonLoading}
              color="primary"
              onClick={() => onReject(dataRemoveCheck)}
            >
              Reject Inspection
            </StyledLoadingButton>
          </SubmitButtonBox>
        </Actions>
      </Content>
    </Container>
  );
};

const Container = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Content = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Head = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
`;

const TitleBar = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SubTitle = styled("p")`
  font-size: 15px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
  margin: 24px 0 20px 0;
  color: ${colors.gray[850]};
`;

const CheckField = styled("div")`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Actions = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  ${(props) => props.theme.breakpoints.down("md")} {
    flex-direction: column;
  }
`;

const CancelButtonBox = styled(Box)`
  width: 184px;
  margin-right: 24px;
  ${(props) => props.theme.breakpoints.down("lg")} {
    width: 100%;
    margin-right: 0;
    margin-bottom: 24px;
  }
`;

const SubmitButtonBox = styled(Box)`
  width: 184px;
  ${(props) => props.theme.breakpoints.down("lg")} {
    width: 100%;
  }
`;
